export function BulletList(props) {
    return <ul>{props.children}</ul>;
}
